import React from "react"
import { useTranslation } from "react-i18next"
import { RotateCcw } from "lucide-react"
import Button from "../ui/Button"
import MobileModal from "./MobileModal"
import renderFilters from "./filterRenderers"

const Container = ({ filterConfig = [], onReset }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="bg-white hidden xl:flex w-[15%] xl:w-[25%] rounded-md shadow-md flex-col h-full pt-4">
        <div className="overflow-hidden px-2 flex-1">{renderFilters(filterConfig, t)}</div>

        <div className="flex items-center px-4 w-full justify-center gap-1 pb-[18px] pt-1">
          <Button onClick={onReset} className="w-full xl:w-auto" color="" size="md">
            <div className="flex items-center justify-center gap-1 text-app-state">
              <RotateCcw size={18} className="text-app-base-strong" />
              <span className="text-app-base-strong">{t("admin.reset")}</span>
            </div>
          </Button>
        </div>
      </div>

      <MobileModal filterConfig={filterConfig} onReset={onReset} />
    </>
  )
}

export default Container
